export default {
  title_1_1: 'Secret',
  title_1_2: 'Safe Box',
  desc_1_2: '견고함, 보안, 쉬운 사용',

  title_2_1: '새로운',
  title_2_2: '디자인',
  desc_2_1:
    '풀 레이저 생산 공정을採用하여 패널을 두껍게 하고 보호 성능을 강화',
  desc_2_2: '더 많은 나사 잠금, 더 많은 안전 잠금, 더욱 단단한 결합',
  desc_2_3: '12개 단어 니모닉 2세트 동시 지원',
  desc_2_4:
    '풀 레이저 공정 / 두꺼운 패널로 보호력 향상 / 나사·안전 잠금 증설 / 12단어 니모닉 2세트 지원',

  title_3_1_1: '놀라운',
  title_3_1_2: '3중 보호',
  desc_3_1:
    '304 스테인리스 스틸 정밀 제작으로 난연성·내열성·내식성을 확보',
  desc_3_2: '방수',
  desc_3_3_1: '정제된 304 스테인리스 소재',
  desc_3_3_2: '방수 및 방식',
  desc_3_3_3: '보관 환경에 친화적',
  desc_3_3_4: '키를 손쉽게 보호',
  desc_3_4: '방화',
  desc_3_5_1: '매우 높은 융점',
  desc_3_5_2: '우수한 내화 성능과 저항',
  desc_3_5_3: '예상치 못한 화재 속에서도',
  desc_3_5_4: '당신의 키를 안전하게',
  desc_3_6: '충격 보호',
  desc_3_7_1: '고강도 제조 공정',
  desc_3_7_2: '더 두꺼운 패널로 더 견고한 결합',
  desc_3_7_3: '예상치 못한 충돌에서도',
  desc_3_7_4: '내부의 모든 문자를 단단히 보호',

  title_4_1: '알파벳 패널',
  desc_4_1_1: '알파벳 패널 Pro 버전',
  desc_4_1_2: '더 편리하게, 더 효율적으로',
  desc_4_2_1:
    '새 디자인으로 더 많은 요구 충족, 6개 패널을 분해해 351개 블록 구성',
  desc_4_2_2:
    '대문자/소문자 지원, 숫자와 기호 문자 추가',
  desc_4_2_3:
    '양면 설계로 총 702자 표시',
  desc_4_3: '351 블록',
  desc_4_4: '대문자/소문자',
  desc_4_5: '숫자/기호 문자',
  desc_4_6: '양면 지원',

  title_5_1: '작동 다이어그램',
  desc_5_1:
    '웹 확장 지갑과 호환. TokenPocket과 완벽히 호환되어 보안과 사용성을 겸비.',
  desc_5_2: 'Step 01',
  desc_5_3: '전면 패널을扇形으로 펼치고 반시계 방향으로 개방',
  desc_5_4: 'Step 02',
  desc_5_5: '드라이버로 나사 5개를 풀기',
  desc_5_6: 'Step 03',
  desc_5_7: '커버 패널을 들어 올리기',
  desc_5_8: 'Step 04',
  desc_5_9: '문자 블록을 슬롯에 넣기',
  desc_5_10: 'Step 05',
  desc_5_11:
    '확인 후 전면 패널을 닫고 나사 5개를 조이기',

  title_6_1: '제품 사양 / 패키지',
  desc_6_1: 'Secret Box Pro',
  desc_6_2:
    '전통적 종이 기록 대비, 안전성과 편의성을 모두 고려. 손쉬운 분해/조립, 문자 블록 배치도 빠르고 간편.',
  desc_6_3: '알파벳 패널',
  desc_6_4:
    '전통적 종이 기록 대비, 안전성과 편의성을 모두 고려. 손쉬운 분해/조립, 문자 블록 배치도 빠르고 간편.',
  desc_6_5: 'EVA 파우치',
  desc_6_6:
    '전통적 종이 기록 대비, 안전성과 편의성을 모두 고려. 손쉬운 분해/조립, 문자 블록 배치도 빠르고 간편.',
  desc_6_7: '소책자/나사/드라이버',
  desc_6_8:
    '전통적 종이 기록 대비, 안전성과 편의성을 모두 고려. 손쉬운 분해/조립, 문자 블록 배치도 빠르고 간편.',

  title_7_1: '기술 사양',
  title_7_2: '특징 및 사용법',
  desc_7_1: 'Secret Box 사양',
  desc_7_2: '크기',
  desc_7_3: '무게',
  desc_7_4: '알파벳 패널 사양',
  desc_7_5: '3피스 1세트, 총 351개 문자 블록',
  desc_7_6: '복수 세트 니모닉 지원',
  desc_7_7:
    'BIP39에 따라 12단어 2세트 또는 18/24단어 1세트 지원',
  desc_7_8: '오프라인 보관',
  desc_7_9:
    '오프라인 보관으로 네트워크를 통한 비밀키 탈취 가능성을 제거',
  desc_7_10: '고품질 소재',
  desc_7_11:
    '튼튼한 스테인리스 소재는 니모닉의 영구 보관에 적합하여 분실 걱정을 덜어줍니다.',
};
